var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M39.2741 18.9999L21.2428 37.0311L17.0002 32.7884L30.7888 18.9999L17.0002 5.21129L21.2428 0.968645L39.2741 18.9999Z","key":0}),React.createElement("path",{"d":"M23.0002 18.9999L4.96896 37.0311L0.726318 32.7884L14.5149 18.9999L0.726324 5.21129L4.96897 0.968643L23.0002 18.9999Z","key":1})]);
}

ArrowRight.defaultProps = {"width":"40","height":"38","viewBox":"0 0 40 38","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
